export const columns = [
  {
    title: "节点",
    dataIndex: "nodeName",
    key: "nodeName",
  },{
    title: "业务类型",
    dataIndex: "systemSource",
    key: "systemSource",
    customRender: (text, record, index) => {
      return text=='1'?'D2C':text=='2'?'B2B':'其他'
    }
  },{
    title: "仓库",
    dataIndex: "warehouse",
    key: "warehouse"
  },{
    title: "模板",
    dataIndex: "templateName",
    key: "templateName"
  },{
    title: "最近修改人",
    dataIndex: "editorName",
    key: "editorName"
  },{
    title: "最近修改时间",
    dataIndex: "updateTime",
    key: "updateTime"
  },{
    title: "操作",
    dataIndex: "action",
    key: "action",
    scopedSlots: {
        customRender: 'action'
    }
  },
];
